import React from 'react';
import autoBind from 'react-autobind';
import SkeletonGrid from '../skeleton/Layout/skeleton.model.grid';

class Container extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
    };
    autoBind(this);
  }

  render() {
    const { modelSkeleton } = this.props;

    if (modelSkeleton == 'Grid') {
      return <SkeletonGrid />;
    }
    return <></>;
  }
}

export default Container;
